import React from 'react';
import RemindBroker from './remind_broker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { fetchTranslation } from '../../../../helpers/i18n';

export default function NotApproved({ readonly = false }) {
  return (
    <div className="text-center my-2">
      <FontAwesomeIcon className="text-branding" icon={faClock} size="2x"/>
      <h5 className="my-6"><strong>{fetchTranslation('broker_confirmation_required')}</strong></h5>
      <p className="mb-0">
        {fetchTranslation('broker_approval_message')}
      </p>
      <RemindBroker readonly={readonly}/>
    </div>
  );
}

NotApproved.propTypes = { readonly: PropTypes.bool };
